import script from "./VVVCreateUserNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVCreateUserNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVCreateUserNew.vue?vue&type=style&index=0&id=6163cd10&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6163cd10"]])

export default __exports__